import { render, staticRenderFns } from "./DateInput.vue?vue&type=template&id=baa83516&"
import script from "./DateInput.vue?vue&type=script&lang=js&"
export * from "./DateInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('baa83516')) {
      api.createRecord('baa83516', component.options)
    } else {
      api.reload('baa83516', component.options)
    }
    module.hot.accept("./DateInput.vue?vue&type=template&id=baa83516&", function () {
      api.rerender('baa83516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Vendor/vuejs-datepicker/src/components/DateInput.vue"
export default component.exports